/* eslint-disable react/destructuring-assignment,react/prop-types,react/react-in-jsx-scope */
/* eslint-disable prefer-arrow-callback,func-names */
import React, { Component } from 'react';
import _ from 'lodash';
import { Modal, notification } from 'antd';
import { withSize } from 'react-sizeme';

import {
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADING,
  VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_NOT_LOADED,
} from '../../store/terminusDrilldown/terminusDrilldownConstants';
import VocabularyListTermObject from '../../store/models/VocabularyListTermObject';
import TableScroller from '../../views/TableScroller';

export default (bottle) => {
  bottle.factory(
    'TerminusDrilldownContainer',
    function ({ TerminusDrilldownView, terminusDrilldownColumns }) {
      // eslint-disable-next-line max-len
      return withSize({ refreshRate: 100, refreshMode: 'throttle' })(class TerminusDrilldownContainer extends TableScroller {
        constructor(props) {
          super(props);
          this.state = {
            scrollY: 0, showDelete: false, showNameEdit: false, searchExcludeIDs: [],
          };
        }

        componentDidMount() {
          this.props.editingWordsReset();
          if (this.isNew) {
            this.props.setListIsNew(true);
            this.props.initNewPredefinedVocabulary();
          } else {
            const vocabularyName = _.get(this, 'props.match.params.name');
            this.props.setCurrentVocabularyNameID(atob(vocabularyName));
            this.props.setListIsNew(false);
          }
          super.componentDidMount();
        }

        get selectRow() {
          return (data) => {
            if (this.props.isEditingVocabulary) {
              this.toggleInRow(data);
            }
          };
        }

        get rowSelection() {
          return {
            selectedRowKeys: this.props.termsCheckList,
            onChange: this.props.setTermCheckList,
          };
        }

        get goBack() {
          return () => {
            this.props.history.push('/vocabulary-lists');
          };
        }

        get goHome() {
          return () => {
            this.props.history.push('/');
          };
        }

        get isNew() {
          return _.get(this.props, 'newList', false);
        }

        get canDelete() {
          const { vocabularyName, currentTermEditedName } = this.props;
          return !this.isNew && (vocabularyName === currentTermEditedName);
        }

        get headline() {
          return this.isNew ? 'New Vocabulary List' : `Vocabulary List "${_.get(this.props, 'vocabularyName', '')}"`;
        }

        get loading() {
          return !this.props.vocabularyName || [
            VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADING,
            VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_NOT_LOADED,
          ].includes(this.props.editingState);
        }

        get size() {
          return _.get(this, 'props.size.width', 0) < 1100 ? 'small' : 'large';
        }

        get uploadProps() {
          const { addKeywords } = this.props;
          return {
            beforeUpload: () => false,
            showUploadList: false,
            accept: '.csv',
            onChange(info) {
              const reader = new FileReader();
              reader.onload = () => {
                const data = reader.result;
                addKeywords(data.toString().split(/[\n\r]+/g));
              };
              reader.readAsText(info.file);
            },
          };
        }

        get deleteVocabulary() {
          return () => {
            Modal.confirm({
              title: 'Delete Vocabulary',
              content: `Delete ${this.props.vocabularyName}?`,
              okText: 'Delete',
              cancelText: 'Cancel',
              onOk: async (done) => {
                this.props.destroyVocabulary();

                notification.success({
                  message: `deleted Custom Vocabulary "${this.props.vocabularyName}"`,
                  description: 'Permanently removed Custom Vocabulary',
                  duration: 2.5,
                  placement: 'topLeft',
                  onOK() {
                    this.goBack();
                  },
                });
                this.goBack();
                done();
              },
            });
          };
        }

        get columns() {
          return terminusDrilldownColumns({
            ...this.props,
            size: this.size,
          });
        }

        get isLoading() {
          return this.props.termState === VOCABULARY_LIST_DRILLDOWN_VOCABULARY_STATE_LOADING;
        }

        get save() {
          return async () => {
            const newVocabularyName = _.trim(_.get(this, 'props.currentTermEditedName', ''));
            const vocabularyName = _.get(this, 'props.vocabularyName', '');
            const terms = _.get(this, 'props.termsEditing', []);
            const data = VocabularyListTermObject.listToData(terms);
            const goBack = this.goBack;

            try {
              await this.props.saveEdits();
              let description = `${data.length} terms.`;

              if (this.isNew) {
                description = `created "${newVocabularyName}" with ${description}`;
              } else if (newVocabularyName === vocabularyName) {
                description = `updated "${newVocabularyName}" with ${description}`;
              } else {
                description = `saved "${vocabularyName}" as "${newVocabularyName}" with ${description}`;
              }

              let s = setTimeout(() => {
                goBack();
                s = null;
              }, 2000);

              notification.success({
                message: `saved Custom Vocabulary "${newVocabularyName}"`,
                description,
                duration: 2.5,
                placement: 'topLeft',
                onOK() {
                  if (s) {
                    clearTimeout(s);
                  }
                  goBack();
                },
              });
            } catch (err) {
              notification.error({
                message: `could not save "${newVocabularyName}"`,
                description: _.get(err, 'error', _.get(err, 'message', 'unknown error')),
              });
            }
          };
        }

        get canSave() {
          const name = _.trim(_.get(this, 'props.currentTermEditedName', ''));
          if (!name) {
            return false;
          }
          const terms = _.get(this, 'props.termsEditing', []);
          if (!VocabularyListTermObject.hasItems(terms)) {
            return false;
          }
          return true;
        }

        get setSearchTerm() {
          return (searchTerm) => {
            if (searchTerm === this.props.searchTerm) return;
            this.props.setEditingSearchTerm(searchTerm);
            if (searchTerm) {
              const searchExcludeIDs = _(this.props.termsEditing)
                .filter(keyword => !keyword.empty && !keyword.has(searchTerm))
                .map('id')
                .value();
              this.setState({ searchExcludeIDs });
            } else {
              this.setState({ searchExcludeIDs: [] });
            }
          };
        }

        get data() {
          const { termsEditing: terms, searchTerm } = this.props;
          const { searchExcludeIDs } = this.state;
          let data = terms;
          if (searchTerm) {
            data = terms.filter(term => !searchExcludeIDs.includes(term.id));
          }
          return data;
        }

        get deleteChecked() {
          return () => {
            if (!_.get(this, 'props.termsCheckList.length')) {
              Modal.confirm({
                title: 'Delete Terms',
                content: 'You must check at least one term to delete',
                okText: 'OK',
              });
            } else {
              this.props.deleteCheckedTerms();
            }
          };
        }

        get revert() {
          return () => {
            this.props.editingWordsReset();
            this.props.fetchVocabulary();
          };
        }

        render() {
          return (
            <TerminusDrilldownView
              {...this.props}
              {...this.state}
              tableProps={({})}
              headline={this.headline}
              size={this.size}
              goBack={this.goBack}
              goHome={this.goHome}
              isNew={this.isNew}
              canSave={this.canSave}
              canDelete={this.canDelete}
              save={this.save}
              selectRow={this.selectRow}
              isLoading={this.isLoading}
              rowSelection={this.rowSelection}
              deleteVocabulary={this.deleteVocabulary}
              addTitle={this.addTitle}
              onCloseDrawer={this.onCloseDrawer}
              uploadProps={this.uploadProps}
              columns={this.columns}
              deleteChecked={this.deleteChecked}
              setSearchTerm={this.setSearchTerm}
              revert={this.revert}
              data={this.data}
            />
          );
        }
      });
    },
  );
};
